import { Avatar, AvatarFallback } from "@repo/ui/components/ui/avatar";
import { Card, CardContent } from "@repo/ui/components/ui/card";
import { patientCardStyles as s } from "./PatientCard.styles";
import type { PatientCardData } from "./PatientCard.types";

function initials(first: string, last: string): string {
  return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
}

export function PatientCard({ first_name, last_name, mrn, dob, gender }: PatientCardData) {
  return (
    <Card className={s.root}>
      <CardContent className={s.nameRow}>
        <Avatar className={s.avatar}>
          <AvatarFallback className={s.avatarFallback}>
            {initials(first_name, last_name)}
          </AvatarFallback>
        </Avatar>
        <div>
          <p className={s.name}>
            {first_name} {last_name}
          </p>
          <p className={s.mrnLine}>MRN {mrn}</p>
        </div>
      </CardContent>

      <CardContent className={s.fields}>
        <div>
          <p className={s.fieldLabel}>Date of birth</p>
          <p className={s.fieldValue}>{dob}</p>
        </div>
        <div>
          <p className={s.fieldLabel}>Gender</p>
          <p className={s.fieldValue}>{gender}</p>
        </div>
      </CardContent>
    </Card>
  );
}
